import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createRemoteVideoMenuButtonEvent } from '../../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../../analytics/functions';
import { IconMicSlash, IconMic, IconVideoOff, IconVideo } from '../../../base/icons/svg';
import { MEDIA_TYPE } from '../../../base/media/constants';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import { muteLocal } from '../../actions.any';
import { handleToggleVideoMuted } from '../../../toolbox/actions.any';
import { isLocalTrackMuted } from '../../../base/tracks/functions.any';
/**
 * Implements a React {@link Component} which displays a button for audio muting
 * a participant in the conference.
 *
 * @returns {JSX.Element|null}
 */
const MuteUnmeteSelfButton = ({ notifyClick, notifyMode, participantID }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const tracks = useSelector((state) => state['features/base/tracks']);
    const audioTrackMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.AUDIO);
    const videoTrackMuted = isLocalTrackMuted(tracks, MEDIA_TYPE.VIDEO);
    const [isToggling, setIsToggling] = useState(false);
    const handleAudioClick = () => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        sendAnalytics(createRemoteVideoMenuButtonEvent('mute', {
            'participant_id': participantID
        }));
        dispatch(muteLocal(!audioTrackMuted, MEDIA_TYPE.AUDIO));
    };
    const handleVideoClick = () => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        dispatch(handleToggleVideoMuted(!videoTrackMuted, true, true));
    };
    const btnlabel = audioTrackMuted ? 'participantsPane.actions.unMute' : 'participantsPane.actions.mute';
    const videoBtnLabel = videoTrackMuted ? 'participantsPane.actions.startVideo' : 'participantsPane.actions.stopVideo';
    return (React.createElement("div", null,
        React.createElement(ContextMenuItem, { accessibilityLabel: t(btnlabel), className: 'selefMuteLink', text: t(btnlabel), icon: audioTrackMuted ? IconMicSlash : IconMic, onClick: handleAudioClick }),
        React.createElement(ContextMenuItem, { accessibilityLabel: t(videoBtnLabel), className: 'selefMuteLink', text: t(videoBtnLabel), icon: videoTrackMuted ? IconVideoOff : IconVideo, onClick: handleVideoClick })));
};
export default MuteUnmeteSelfButton;
